"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _class, _descriptor, _temp;

var DateBlock = (_class = (_temp =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(DateBlock, _Block);

  function DateBlock() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, DateBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(DateBlock)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "format", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(DateBlock, [{
    key: "getChildren",
    value: function getChildren() {
      return new Date().format(this.format);
    }
  }]);
  return DateBlock;
}(_base.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "format", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = DateBlock;